const topicLabels: Record<string, string> = {
  software: '软件开发',
  ai: '人工智能',
  chips: '芯片',
  cybersecurity: '网络安全',
  macro_economy: '宏观经济',
  monetary_policy: '货币政策',
  financial_markets: '金融市场',
  politics_policy: '政治与政策',
  world_affairs: '国际事务',
  energy: '能源',
  developer_tools: '开发者工具',
  science: '科学',
}

export const topicLabel = (topic: string) => topicLabels[topic] ?? topic.replaceAll('_', ' ')
